import { ClaimAction, ClaimActionTypes, ClaimState } from "./types";

const initialState: ClaimState = {
  id: "",
  claimNumber: "",
  email: "",
  phoneNumber: "",
  city: "",
  state: "",
  address1: "",
  address2: "",
  zip: "",
  WarrantyProgramName: "",
  claimFileDate: "",
  planNumber: "",
  dealerName: "",
  purchaseDate: null,
  deliveryDate: null,
  planAgreement: "",
  claimItems: [],
  status_code: "",
  status: null,
  documents: [],
  customerName: "",
  emails: [],
  customerActionDetail: "",
  denied: false,
};

export const claimReducer = (
  state: ClaimState = initialState,
  action: ClaimActionTypes
): ClaimState => {
  switch (action.type) {
    case ClaimAction.SET_CLAIM_RECORD: {
      return {
        ...state,
        ...(action.payload || {}),
      };
    }
    case ClaimAction.CLEAN_UP: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
